import {stage} from './stage';

export const platformByStage = {
    prod: {
        portal: 'https://portal.flexi.network',
        console: 'https://console.flexi.network',
        domains: 'https://www.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.flexi.network',
        platform: 'https://platform.flexi.network',
        directory: 'https://www.flexi.directory',
    },
    test: {
        portal: 'https://portal.test.flexi.network',
        console: 'https://console.test.flexi.network',
        domains: 'https://test.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.test.flexi.network',
        platform: 'https://platform.test.flexi.network',
        directory: 'https://test.flexi.directory',
    },
    dev: {
        portal: 'https://portal.dev.flexi.network',
        console: 'https://console.dev.flexi.network',
        domains: 'https://dev.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.dev.flexi.network',
        platform: 'https://platform.dev.flexi.network',
        directory: 'https://dev.flexi.directory',
    },
    ide: {
        portal: 'https://localhost:8011',
        console: 'https://localhost:8012',
        domains: 'https://localhost:8021',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://localhost:8024',
        platform: 'https://localhost:8025',
        directory: 'https://localhost:8027',
    },
};

export default platformByStage[stage];
